import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'deletedMapFilter',
  standalone: true
})
export class DeletedMapFilterPipe implements PipeTransform {
  transform(items: any[], filterByDeleted: boolean): any[] {
    if (!items) {
      return [];
    }

    if (filterByDeleted) {
      return items.filter(item => {
        return item.state !== 'deleted';
      });
    } else {
      return items;
    }
  }
}
